
/**
 * When I wrote this code,Only God and I understood what I was doing.
 * Now,God only knows  !!!
 */
import {Component, Prop, Ref, Vue, Watch} from "vue-property-decorator";
import ChatTool from "@/components/messageInteraction/chat-tool.vue";
import ChatMessage from "@/components/messageInteraction/chat-message.vue";
import {SizeEnum, UserType} from "@/ts/Enum";
import UserChat from "@/ts/UserChat";
import {
  Announcement,
  AnnouncementInfo,
  ChatMessage as ChatMessageTs,
  ChatMessageInfo,
  MessageBase,
  SendAnnouncementUserInfo
} from "@/ts/Announcement";
import MqttClient from "@/mqtt/mqttClient";

@Component({
  components: {ChatMessage, ChatTool}
})
export default class Chat extends Vue {
  @Prop({default: 780})
  height: number
  @Prop({default: UserType.teacher})
  userType: UserType
  @Prop({default: null})
  userInfo: UserChat
  @Prop({default: false})
  isSend: boolean
  @Prop()
  subscriptionList: any

  @Prop() activityMessageBase: MessageBase
  @Ref() readonly widthN
  type: SizeEnum = SizeEnum.medium
  isNotice = false
  notice = ''
  userList = []
  currentUser: UserChat

  headerToolList = [
    {
      key: 1,
      name: '发布公告',
      text: '',
      visable: false,
      width: 400,
      clickM: this.pushNotice
    },
    // {
    //     key: 2,
    //     name: '全员禁言',
    //     clickM: this.shutup
    // },
    // {
    //     key: 3,
    //     name: '实时画面预览模式',
    //     clickM: this.preview
    // }
  ]
  @Ref() readonly chatMessageRef


  mounted(): void {
    this.getCurrentUser();
    this.getType();
  }

  getType() {
    function cw(_this) {
      _this.$nextTick(() => {
        let clientWidth = document.getElementById("widthN").offsetWidth
        console.log(clientWidth)
        _this.type = clientWidth > 600 ? SizeEnum.medium : SizeEnum.small;
        _this.$nextTick(() => {
          _this.chatMessageRef.initContentHeight()
        })
      })
    }

    let _this = this;
    cw(_this);
    window.onresize = () => {
      return (() => {
        cw(_this);
      })()
    }
  }

  init() {
    this.getType();
    this.chatMessageRef.scrollTop();
  }

  @Watch("userList", {deep: true, immediate: true})
  scrollTop(nv, ov) {
    this.$emit("messageCountChange", nv.length)
    if (this.chatMessageRef)
      this.chatMessageRef.scrollTop();
  }

  // @Watch("height", {deep: true, immediate: true})
  // setStyleHeight(nv, ov) {
  //     // let ele = document.getElementById("widthN");
  //     // console.log(ele)
  //     // if (ele) {
  //     //     ele.style.height = nv + 'px';
  //     // }
  //
  // }

  @Watch("isSend", {deep: true, immediate: true})
  isSendWatch() {
    if (!this.isSend) {
      // this.$message.success("我要清空数据了。。。")
      this.clearAll();
    }
  }

  clearAll() {
    this.notice = "";
    this.isNotice = false;
    this.userList = [];
  }

  /**
   * 获取当前登录用户
   */
  getCurrentUser() {
    // 参与者信息是通过userinfo属性传递进来的
    if (this.userInfo) {
      this.currentUser =
          new UserChat(this.userInfo.id, this.userInfo.name, this.userInfo.type, this.filePre$.headImgUrl, null, null)
      return
    }
    // 登录后的发起者（教师）的信息，是从缓存中获取的
    const us: string = window.localStorage.getItem("userInfo");
    if (us) {
      let user = JSON.parse(us);
      if (this.userType == UserType.teacher) {
        this.currentUser = new UserChat(user.accountId, user.displayName, UserType.teacher, this.filePre$.headImgUrl + user.imgUrl, user.gender, null);
      } else if (this.userType == UserType.student) {
        this.currentUser = new UserChat(user.uid, user.name, UserType.student, this.filePre$.headImgUrl + user.imgUrl, user.gender, null);
      }
      return
    }
    // 未登录的发起者，需要根据活动的基本信息推断
    if (this.activityMessageBase) {
      this.currentUser = new UserChat(this.activityMessageBase.activity_teacher_id, this.activityMessageBase.activity_teacher_name, UserType.teacher, this.filePre$.headImgUrl, null, null);
    }
  }


  sendMessage(textarea) {
    if (!this.isSend) {
      this.$message.warning("您需要“开始上课”后才能使用留言功能！");
      return;
    }
    this.currentUser.setMessage(textarea);
    let chatMessage = new ChatMessageTs(this.activityMessageBase)
    chatMessage.activity_type = "RTC_INTERACTIVE_CLASS";
    chatMessage.send_message_user_info =
        new SendAnnouncementUserInfo(
            this.userType,
            this.currentUser.id,
            this.currentUser.name,
            this.currentUser.imgUrl,
            this.currentUser.gender
        );
    chatMessage.chat_message_info =
        new ChatMessageInfo(new Date().getTime().toString(),
            "txt", this.currentUser.getMessage());
    MqttClient.instance.doPublish(
        {
          topic: this.subscriptionList[0].topic,
          payload: JSON.stringify(chatMessage),
          qos: 1,
          retain: true,
        });
  }

  processMessage(data) {
    console.log(`data: ${data.topic},=>${data.message}`);
    const message = data.message;
    this.chatMessage(data.topic, message);
    this.noticMessage(data.topic, message);
  }

  chatMessage(topic, message) {
    const pattern = new RegExp(this.subscriptionList[0].pattern, "g");
    if (pattern.test(topic)) {
      let chatMessage = message as ChatMessageTs;
      if (chatMessage.activity_type == "RTC_INTERACTIVE_CLASS") {

        let sendMessageUserInfo = chatMessage.send_message_user_info;
        let chatMessageInfo = chatMessage.chat_message_info;
        let user = new UserChat(sendMessageUserInfo.user_id,
            sendMessageUserInfo.user_name,
            sendMessageUserInfo.user_type,
            sendMessageUserInfo.user_img_src,
            sendMessageUserInfo.user_gender,
            chatMessageInfo.message_content);
        if (this.currentUser.id === user.id) {
          user.placement = "right";
        } else {
          user.placement = "left";
        }
        this.userList.push(user);
      }


    }
  }

  noticMessage(topic, message) {
    const pattern = new RegExp(this.subscriptionList[1].pattern, "g");
    if (pattern.test(topic)) {
      let announcement = message as Announcement;
      if (announcement.activity_type == "RTC_INTERACTIVE_CLASS") {
        this.notice = announcement.announcement_info.announcement_content;
        this.isNotice = true;
        this.$nextTick(() => {
          this.chatMessageRef.initContentHeight()
        })
      }
    }
  }

  pushNotice() {
    if (this.isSend) {
      this.headerToolList[0].visable = !this.headerToolList[0].visable
    } else {
      this.$message.warning("您需要“开始上课”后才能使用发布公告功能！");
    }

  }

  pushNoticeConfirm() {
    //发送公告信息,清空公告内容
    let text = this.headerToolList[0].text;
    this.headerToolList[0].text = '';
    let announcement = new Announcement(this.activityMessageBase)
    announcement.activity_type = "RTC_INTERACTIVE_CLASS";
    announcement.send_announcement_user_info = new SendAnnouncementUserInfo(this.userType, this.currentUser.id, this.currentUser.name);
    announcement.announcement_info = new AnnouncementInfo(new Date().getTime().toString(), text);
    MqttClient.instance.doPublish(
        {
          topic: this.subscriptionList[1].topic,
          qos: 1,
          retain: true,
          payload: JSON.stringify(announcement)
        });
    this.pushNotice();
  }

}
